import { render, staticRenderFns } from "./failedOrder.vue?vue&type=template&id=7cc98489&scoped=true"
import script from "./failedOrder.vue?vue&type=script&lang=js"
export * from "./failedOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc98489",
  null
  
)

export default component.exports